module.exports = __webpack_public_path__ + "img/11.504a15b0.webp";